export const HEADER_PROFILE_MENU_CLICK =
  'Customer-Session.Web-App.Header.Profile-Menu.click';
export const HEADER_SHOPPING_CART_BTN_CLICK =
  'Customer-Session.Web-App.Header.Shopping-Cart-BTN.click';
export const HEADER_SIGNOUT_BTN_CLICK =
  'Customer-Session.Web-App.Header.SignOut-BTN.click';
export const HEADER_LOGO_CLICK = 'Customer-Session.Web-App.Header.Logo.click';

export const STR_DASHBOARD = 'Dashboard';
export const STR_ORDERS = 'Orders';
export const STR_GENIE = 'Genie';
export const STR_PROFILE = 'Profile';
export const STR_POSTURE_CHECK = 'Posture Check';
export const STR_MEASUREMENTS = 'Measurements';
export const STR_SIGNOUT = 'Signout';
